import { render, staticRenderFns } from "./swipimgs.vue?vue&type=template&id=10774ec1"
import script from "./swipimgs.vue?vue&type=script&lang=js"
export * from "./swipimgs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports